import { coachmarkSchema } from './schema';
export var getEnabledCoachmarks = function (_a) {
    var allyUserRole = _a.allyUserRole, ffVariation = _a.ffVariation, hostData = _a.hostData, pathname = _a.pathname, session = _a.session;
    var enabledCoachmarks = [];
    for (var i = 0; i < coachmarkSchema.length; i += 1) {
        var coachmark = coachmarkSchema[i];
        if (coachmark.isCoachmarkEnabled(ffVariation) &&
            coachmark.scope({
                allyUserRole: allyUserRole,
                hostData: hostData,
                pathname: pathname,
                session: session,
            })) {
            enabledCoachmarks.push({
                name: coachmark.name,
                summary: coachmark.summary({
                    allyUserRole: allyUserRole,
                    ffVariation: ffVariation,
                    hostData: hostData,
                    session: session,
                }),
                detailView: coachmark.detailView,
            });
        }
    }
    return enabledCoachmarks;
};
//# sourceMappingURL=utils.js.map